import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { $authUserId, logoutSucceeded } from '~/entities/auth';
import { STORE_KEY } from '~/shared/constants';
import { clearResponsiveModals } from '~/shared/ui/ResponsiveModals';
import { hasStoredAccessToken } from '../utils';

export const useAuthQuerySync = () => {
    const queryClient = useQueryClient();

    useEffect(() => {
        let previousUserId = $authUserId.getState();

        const subscription = $authUserId.updates.watch((userId) => {
            const leftAuthenticatedPrincipal = previousUserId !== null && previousUserId !== userId;

            previousUserId = userId;

            if (leftAuthenticatedPrincipal) {
                clearResponsiveModals();
                queryClient.clear();
            }
        });

        const handleStorage = (event: StorageEvent) => {
            const belongsToLocalStorage = event.storageArea === null || event.storageArea === localStorage;
            const changedAppStore = event.key === null || event.key === STORE_KEY;

            if (
                !belongsToLocalStorage ||
                !changedAppStore ||
                $authUserId.getState() === null ||
                hasStoredAccessToken(event.newValue)
            ) {
                return;
            }

            logoutSucceeded();
        };

        window.addEventListener('storage', handleStorage);

        return () => {
            subscription.unsubscribe();
            window.removeEventListener('storage', handleStorage);
        };
    }, [queryClient]);
};
